import React, { JSXElementConstructor, ReactElement, ReactNodeArray } from 'react'
import { FormattedMessage as IntlMessage } from 'react-intl'

interface IProps {
  id: string
  defaultMessage?: string
  values?: { [key: string]: string | React.ReactElement }
     // children?: React.ReactElement<any, string | JSXElementConstructor<any>> | null
  //children?: (pl: string) => Element
  children?: (nodes: ReactNodeArray) => ReactElement<any, string | JSXElementConstructor<any>> | null
}

export default function FormattedMessage({
  id,
  defaultMessage,
  children,
  ...rest
}: IProps) {
  return children ? (
    <IntlMessage id={id} defaultMessage={defaultMessage || id} {...rest}>
      {children as any}
    </IntlMessage>
  ) : (
    <IntlMessage id={id} defaultMessage={defaultMessage || id} {...rest} />
  )
}
